import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
interface ProposalCardOutlineProps {
  title: string;
  className?: string;
  children: React.ReactNode;
}
function ProposalCardOutline(t0) {
  const $ = _c(10);
  const {
    title,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("bg-background flex w-full flex-col gap-4 rounded-lg border p-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <div className="text-foreground/50 text-center leading-6 font-semibold uppercase">{title}</div>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <div className="h-full">{children}</div>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export { ProposalCardOutline };